import React from 'react'
import Button from '../components/Button'

const MicroWaveCompPopUp = (props) => {
  return (
    <div className='compZonepopupOnlyMDone'>
      <div className='compPopUpWidthOnlyMDone'>
        <Button
        clickFunction={props.closeRadioPopUpf} 
        classList="closePopup"
        >
        {/* &#10005; */}
        </Button>

        <div className='popupContent'>
          <p>
            <b>
              This Microwave Drawer Oven is only compatible with the SKCD24U0GS
            </b>
          </p>
          {/* <p>
            The Under-the-Counter Pedestals is not compatible in <b>Zone 7</b> with <b>SWA2450GS</b> wallOven
          </p> */}
          <Button
          classList="compPopUp"
          clickFunction={props.closeRadioPopUpf}
          >OK</Button>
        </div>

      </div>
    </div>
  )
}

export default MicroWaveCompPopUp